<template>
    <layout-gestao>
        <div class="row">
            <div class="col-sm-12">
                <form
                    autocomplete="off"
                    method="post"
                    data-vv-scope="form"
                    @submit.prevent="() => {}"
                >
                    <div class="row mb-3">
                        <div class="col-sm-auto">
                            <h1 class="content-title">{{ titleItem }}</h1>
                        </div>
                    </div>
                    <nav>
                        <div
                            class="nav nav-tabs nav-fill mb-3 sky-blue"
                            id="nav-tab"
                            role="tablist"
                        >
                            <a
                                v-for="(tab, idx) in tabs"
                                :key="`tab-${tab['name']}`"
                                @click.prevent="localActive = tab"
                                :href="`#${tab['code']}`"
                                class="nav-item nav-link"
                                :class="{ active: localActive == tab }"
                                data-toggle="tab"
                                role="tab"
                                :aria-selected="localActive == tab"
                            >
                                {{ tab['name'] }}
                            </a>
                        </div>
                    </nav>
                    <div
                        class="tab-content"
                        id="nav-tabContent"
                    >
                        <!-- General -->
                        <div
                            class="tab-pane fade"
                            :class="{ 'show active': localActive == tabs[0] }"
                            id="nav-general"
                            role="tabpanel"
                            aria-labelledby="nav-general-tab"
                        >
                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="form-group">
                                        <MaterialSelect
                                            :disabled="readonlyFormItem"
                                            class="city-form-group city-bg"
                                            id="input-entity_id"
                                            name="entity_id"
                                            label="name"
                                            :filterable="true"
                                            :options="lists.entities"
                                            v-model.trim="form.entity_id"
                                            v-validate="'required'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('entity_id') }]"
                                            :error="fnFirstError('entity_id')"
                                            :helpText="$t(`${pageID}.help.entity`)"
                                        >
                                            {{ $t(`${pageID}.model.entity`) }}
                                        </MaterialSelect>
                                    </div>
                                </div>
                                <div class="col-sm-7">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-name"
                                            name="name"
                                            v-model.trim="form.name"
                                            v-validate="'required|min:3'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('name') }]"
                                            :error="fnFirstError('name')"
                                        >
                                            {{ $t(`${pageID}.model.name`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-5">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-address"
                                            name="address"
                                            v-model.trim="form.address"
                                            v-validate="'min:3'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('address') }]"
                                            :error="fnFirstError('address')"
                                        >
                                            {{ $t(`${pageID}.model.address`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-6 col-lg-5">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="email"
                                            class="city-form-group city-bg"
                                            id="input-email"
                                            name="email"
                                            v-model.trim="form.email"
                                            v-validate="'emails'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('email') }]"
                                            :error="fnFirstError('email')"
                                            :helpText="$t(`${pageID}.help.email`)"
                                        >
                                            {{ $t(`${pageID}.model.email`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-6 col-lg-4">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-phone"
                                            name="phone"
                                            v-model.trim="form.phone"
                                            v-validate="'phones'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('phone') }]"
                                            :error="fnFirstError('phone')"
                                            :helpText="$t(`${pageID}.help.phone`)"
                                        >
                                            {{ $t(`${pageID}.model.phone`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-4 col-lg-3">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="number"
                                            class="city-form-group city-bg"
                                            id="input-n_operational"
                                            name="n_operational"
                                            v-model.trim="form.n_operational"
                                            v-validate="'integer|min_value:1'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('n_operational') }]"
                                            :error="fnFirstError('n_operational')"
                                            :helpText="$t(`${pageID}.help.n_operational`)"
                                        >
                                            {{ $t(`${pageID}.model.n_operational`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-lat"
                                            name="lat"
                                            v-model.trim="form.lat"
                                            v-validate="{ lat: { checkDMS: true } }"
                                            :inputClasses="[{ 'is-invalid': fnHasError('lat') }]"
                                            :error="fnFirstError('lat')"
                                            :helpText="$t(`${pageID}.help.lat`)"
                                        >
                                            {{ $t(`${pageID}.model.lat`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <MaterialInput
                                            :readonly="readonlyFormItem"
                                            type="text"
                                            class="city-form-group city-bg"
                                            id="input-lng"
                                            name="lng"
                                            v-model.trim="form.lng"
                                            v-validate="{ lng: { checkDMS: true } }"
                                            :inputClasses="[{ 'is-invalid': fnHasError('lng') }]"
                                            :error="fnFirstError('lng')"
                                            :helpText="$t(`${pageID}.help.lng`)"
                                        >
                                            {{ $t(`${pageID}.model.lng`) }}
                                        </MaterialInput>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <div class="form-group city-form-group city-bg mb-0">
                                        <MaterialTextarea
                                            :disabled="readonlyFormItem"
                                            :rows="4"
                                            class="city-form-group city-bg"
                                            id="input-skills"
                                            name="skills"
                                            v-model.trim="form.skills"
                                            v-validate="'min:3'"
                                            :inputClasses="[{ 'is-invalid': fnHasError('skills') }]"
                                            :error="fnFirstError('skills')"
                                        >
                                            {{ $t(`${pageID}.model.skills`) }}
                                        </MaterialTextarea>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-12">
                                    <upload-multiple-file
                                        :disabled="readonlyFormItem"
                                        v-model="form.files"
                                        :acceptTypes="acceptTypes"
                                        :maxFiles="maxFiles"
                                        name="files"
                                        v-validate="''"
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- Types -->
                        <div
                            class="tab-pane fade"
                            :class="{ 'show active': localActive == tabs[1] }"
                            id="nav-types"
                            role="tabpanel"
                            aria-labelledby="nav-types-tab"
                        >
                            <div class="row">
                                <div class="col">
                                    <types-list
                                        :moduleId="moduleCode"
                                        :readonlyFormItem="readonlyFormItem"
                                        :data="families"
                                        v-model="form.types"
                                        v-validate=""
                                    />
                                </div>
                            </div>
                        </div>

                        <!-- Human Means -->
                        <div
                            class="tab-pane fade"
                            :class="{ 'show active': localActive == tabs[2] }"
                            id="nav-agents"
                            role="tabpanel"
                            aria-labelledby="nav-agents-tab"
                        >
                            <div class="row">
                                <div class="col-sm-12">
                                    <table-data
                                        v-if="loaded"
                                        :route="tableHumanMeans.url"
                                        :settings="tableHumanMeans.settings"
                                        :columns="tableHumanMeans.columns"
                                        :inlineFilters="tableHumanMeans.filters"
                                        :autoUpdateFilter="tableHumanMeans.autoUpdateFilter"
                                        :addParamsToUrl="tableHumanMeans.addParamsToUrl"
                                        :loadingMsg="tableHumanMeans.loadingMsg"
                                        :noDataMsg="tableHumanMeans.notFoundMsg"
                                        :orderByTemplate="tableHumanMeans.orderByTemplate"
                                        :showPagination="tableHumanMeans.showPagination"
                                        :tableInline="tableHumanMeans.tableInline"
                                        @error-load="showError"
                                        name="agents"
                                        v-validate=""
                                    >
                                        <template
                                            v-slot:title="{ add }"
                                            v-if="!readonlyFormItem"
                                        >
                                            <div class="row">
                                                <div class="col-12">
                                                    <MaterialSelect
                                                        class="city-form-group city-bg"
                                                        size="small"
                                                        v-model="agent"
                                                        :label="tableHumanMeans.label"
                                                        :placeholder="tableHumanMeans.placeholder"
                                                        :ajaxOptions="{
                                                            url: tableHumanMeans.urlSearch
                                                        }"
                                                        :reduce="option => option"
                                                    >
                                                        <template v-slot:option="{ option }">
                                                            <div v-html="tableHumanMeans.funcItemHtml(option)"></div>
                                                        </template>

                                                        <template v-slot:grpAppend>
                                                            <button
                                                                class="btn btn-main"
                                                                :disabled="!agent"
                                                                type="button"
                                                                @click.prevent="addItem('agent', add)"
                                                            >
                                                                {{ tableHumanMeans.addTitle }}
                                                            </button>
                                                        </template>
                                                    </MaterialSelect>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-slot:body="{ columns, row, index, remove }">
                                            <td :class="columns[0].class">
                                                <router-link
                                                    target="_blank"
                                                    :to="{ name: `${userModuleCode}.${userPageID}.show`, params: { id: row.id } }"
                                                >
                                                    {{ columnValue(row, columns[0]) }}
                                                </router-link>
                                            </td>
                                            <td :class="columns[1].class">
                                                {{ columnValue(row, columns[1]) }}
                                            </td>
                                            <td :class="columns[2].class">
                                                {{ columnValue(row, columns[2]) }}
                                            </td>
                                            <column-actions
                                                v-if="checkActions"
                                                @delete="id => removeItem(id, 'agent', remove)"
                                                :deleteMsgTemplate="`${pageID}.list.agent.deleteMsg`"
                                                :label="columns[0].field"
                                                :canDetail="false"
                                                :canEdit="false"
                                                :canDelete="canDelete"
                                                :row="row"
                                                :index="index"
                                            />
                                        </template>
                                    </table-data>
                                </div>
                            </div>
                        </div>

                        <!-- Material Means -->
                        <div
                            class="tab-pane fade"
                            :class="{ 'show active': localActive == tabs[3] }"
                            id="nav-materials"
                            role="tabpanel"
                            aria-labelledby="nav-materials-tab"
                        >
                            <div class="row">
                                <div class="col">
                                    <h6 class="font-weight-normal">{{ $t(`${pageID}.model.vehicles`) }}</h6>
                                    <hr class="mt-2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <table-data
                                        v-if="loaded"
                                        :route="tableVehicles.url"
                                        :settings="tableVehicles.settings"
                                        :columns="tableVehicles.columns"
                                        :inlineFilters="tableVehicles.filters"
                                        :autoUpdateFilter="tableVehicles.autoUpdateFilter"
                                        :addParamsToUrl="tableVehicles.addParamsToUrl"
                                        :loadingMsg="tableVehicles.loadingMsg"
                                        :noDataMsg="tableVehicles.notFoundMsg"
                                        :orderByTemplate="tableVehicles.orderByTemplate"
                                        :showPagination="tableVehicles.showPagination"
                                        :tableInline="tableVehicles.tableInline"
                                        @error-load="showError"
                                        name="vehicles"
                                        v-validate=""
                                    >
                                        <template
                                            v-slot:title="{ add }"
                                            v-if="!readonlyFormItem"
                                        >
                                            <div class="row">
                                                <div class="col-12">
                                                    <MaterialSelect
                                                        class="city-form-group city-bg"
                                                        size="small"
                                                        v-model="vehicle"
                                                        :label="tableVehicles.label"
                                                        :placeholder="tableVehicles.placeholder"
                                                        :ajaxOptions="{
                                                            url: tableVehicles.urlSearch
                                                        }"
                                                        :reduce="option => option"
                                                    >
                                                        <template v-slot:option="{ option }">
                                                            <div v-html="tableVehicles.funcItemHtml(option)"></div>
                                                        </template>
                                                        <template v-slot:grpAppend>
                                                            <button
                                                                class="btn btn-main"
                                                                :disabled="!vehicle"
                                                                type="button"
                                                                @click.prevent="addItem('vehicle', add)"
                                                            >
                                                                {{ tableVehicles.addTitle }}
                                                            </button>
                                                        </template>
                                                    </MaterialSelect>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-slot:body="{ columns, row, index, remove }">
                                            <td :class="columns[0].class">
                                                <router-link
                                                    target="_blank"
                                                    :to="{ name: `${vehicleModuleCode}.${vehiclePageID}.show`, params: { id: row.id } }"
                                                >
                                                    {{ columnValue(row, columns[0]) }}
                                                </router-link>
                                            </td>
                                            <!--
                                            <column-actions
                                                v-if="checkActions"
                                                @delete="(id)=>removeItem(id, 'vehicle', remove)"
                                                :deleteMsgTemplate="`${pageID}.list.vehicle.deleteMsg`"
                                                :label="columns[0].field"
                                                :canDetail="false"
                                                :canEdit="false"
                                                :canDelete="canDelete"
                                                :row="row"
                                                :index="index" />
                                            -->
                                        </template>
                                    </table-data>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col">
                                    <h6 class="font-weight-normal">{{ $t(`${pageID}.model.radios`) }}</h6>
                                    <hr class="mt-2" />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12">
                                    <table-data
                                        v-if="loaded"
                                        :route="tableRadios.url"
                                        :settings="tableRadios.settings"
                                        :columns="tableRadios.columns"
                                        :inlineFilters="tableRadios.filters"
                                        :autoUpdateFilter="tableRadios.autoUpdateFilter"
                                        :addParamsToUrl="tableRadios.addParamsToUrl"
                                        :loadingMsg="tableRadios.loadingMsg"
                                        :noDataMsg="tableRadios.notFoundMsg"
                                        :orderByTemplate="tableRadios.orderByTemplate"
                                        :showPagination="tableRadios.showPagination"
                                        :tableInline="tableRadios.tableInline"
                                        @error-load="showError"
                                        name="radios"
                                        v-validate=""
                                    >
                                        <template
                                            v-slot:title="{ add }"
                                            v-if="!readonlyFormItem"
                                        >
                                            <div class="row">
                                                <div class="col-12">
                                                    <MaterialSelect
                                                        class="city-form-group city-bg"
                                                        size="small"
                                                        v-model="radio"
                                                        :minLen="1"
                                                        :label="tableRadios.label"
                                                        :placeholder="tableRadios.placeholder"
                                                        :ajaxOptions="{
                                                            url: tableRadios.urlSearch
                                                        }"
                                                        :reduce="option => option"
                                                    >
                                                        <template v-slot:option="{ option }">
                                                            <div v-html="tableRadios.funcItemHtml(option)"></div>
                                                        </template>
                                                        <template v-slot:grpAppend>
                                                            <button
                                                                class="btn btn-main"
                                                                :disabled="!agent"
                                                                type="button"
                                                                @click.prevent="addItem('radio', add)"
                                                            >
                                                                {{ tableRadios.addTitle }}
                                                            </button>
                                                        </template>
                                                    </MaterialSelect>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-slot:body="{ columns, row }">
                                            <td :class="columns[0].class">
                                                {{ columnValue(row, columns[0]) }}
                                            </td>
                                            <td :class="columns[1].class">
                                                <router-link
                                                    target="_blank"
                                                    :to="{ name: `${radioModuleCode}.${radioPageID}.show`, params: { id: row.id } }"
                                                >
                                                    {{ columnValue(row, columns[1]) }}
                                                </router-link>
                                            </td>
                                            <!--
                                            <column-actions
                                                v-if="checkActions"
                                                @delete="(id)=>removeItem(id, 'radio', remove)"
                                                :deleteMsgTemplate="`${pageID}.list.radio.deleteMsg`"
                                                :label="columns[0].field"
                                                :canDetail="false"
                                                :canEdit="false"
                                                :canDelete="canDelete"
                                                :row="row"
                                                :index="index"/>
                                            -->
                                        </template>
                                    </table-data>
                                </div>
                            </div>
                        </div>
                    </div>

                    <buttons-footer
                        :enableButtons="!readonlyFormItem"
                        :cancelTitle="cancelTitle"
                        :submitTitle="submitTitle"
                        :isDisabled="isDisabled"
                        @save="onSaveItem"
                        @cancel="handleBack(`${moduleCode}.${pageID}`)"
                    >
                    </buttons-footer>
                </form>
            </div>
        </div>
    </layout-gestao>
</template>

<script>
import mixin from '../../mixin';

export default {
    mixins: [mixin],
    components: {
        TypesList: () => import(/* webpackChunkName: "recursive-list" */ '@/app/shared/components/Types/List.vue'),
        UploadMultipleFile: () => import(/* webpackChunkName: "upload-file" */ '@/components/form/UploadMultipleFile')
    },
    data() {
        let pageID = 'unities';
        return {
            pageID: pageID,
            userPageID: 'agents',
            userModuleCode: 'cosicentral',
            vehiclePageID: 'vehicles',
            vehicleModuleCode: 'cosicentral',
            radioPageID: 'radios',
            radioModuleCode: 'cosicentral',
            agent: null,
            vehicle: null,
            radio: null,
            loaded: false,
            lists: {
                entities: [],
                families: [],
                loaded: false
            },
            form: {
                id: null,
                name: null,
                address: null,
                email: null,
                phone: null,
                n_operational: null,
                skills: null,
                lat: null,
                lng: null,
                entity_id: null,
                files: [],
                types: [],
                vehicles: [],
                radios: [],
                agents: {
                    add: [],
                    del: []
                },
                vehicles: {
                    add: [],
                    del: []
                },
                radios: {
                    add: [],
                    del: []
                }
            },
            tableHumanMeansConfig: {
                addTitle: this.$t(`${pageID}.list.agent.add`),
                placeholder: this.$t(`${pageID}.list.agent.placeholder`),
                addParamsToUrl: false,
                showPagination: true,
                notFoundMsg: this.$t(`${pageID}.list.agent.notFoundMsg`),
                settings: {
                    sort: 'asc',
                    order_by: 'user.name'
                },
                columns: [
                    // {
                    //     label: this.$t(`${pageID}.list.agent.unity`),
                    //     field:  'unity_label',
                    //     sortable: false,
                    // },
                    {
                        label: this.$t(`${pageID}.list.agent.name`),
                        field: 'full_name',
                        sortable: false
                    },
                    {
                        label: this.$t(`${pageID}.list.agent.email`),
                        field: 'email',
                        sortable: false
                    },
                    {
                        label: this.$t(`${pageID}.list.agent.contact`),
                        field: 'contact',
                        sortable: false
                    },
                    {
                        label: '',
                        field: null,
                        sortable: false,
                        class: 'actions'
                    }
                ],
                emptyData: []
            },
            tableVehiclesConfig: {
                addTitle: this.$t(`${pageID}.list.vehicle.add`),
                placeholder: this.$t(`${pageID}.list.vehicle.placeholder`),
                addParamsToUrl: false,
                showPagination: true,
                notFoundMsg: this.$t(`${pageID}.list.vehicle.notFoundMsg`),
                settings: {
                    sort: 'asc',
                    order_by: 'registration'
                },
                columns: [
                    {
                        label: this.$t(`${pageID}.list.vehicle.name`),
                        field: 'full_name',
                        class: 'text-nowrap',
                        sortable: false
                    }
                    // {
                    //     label: '',
                    //     field:  null,
                    //     sortable: false,
                    //     class: 'actions',
                    // }
                ]
            },
            tableRadiosConfig: {
                addTitle: this.$t(`${pageID}.list.radio.add`),
                placeholder: this.$t(`${pageID}.list.radio.placeholder`),
                addParamsToUrl: false,
                showPagination: true,
                notFoundMsg: this.$t(`${pageID}.list.radio.notFoundMsg`),
                settings: {
                    sort: 'asc',
                    order_by: 'radio_type_id'
                },
                columns: [
                    {
                        label: this.$t(`${pageID}.list.radio.radio_type`),
                        field: 'radio_type_label',
                        sortable: false
                    },
                    {
                        label: this.$t(`${pageID}.list.radio.code`),
                        field: 'code',
                        sortable: false,
                        class: 'text-nowrap'
                    }
                    // {
                    //     label: '',
                    //     field:  null,
                    //     sortable: false,
                    //     class: 'actions',
                    // }
                ],
                emptyData: []
            },
            tabs: [
                {
                    code: 'commun',
                    name: this.$t(`${pageID}.list.tabs.commun`),
                    active: true
                },
                {
                    code: 'types',
                    name: this.$t(`${pageID}.list.tabs.types`),
                    active: true
                },
                {
                    code: 'agents',
                    name: this.$t(`${pageID}.list.tabs.agents`),
                    active: true
                },
                {
                    code: 'materials',
                    name: this.$t(`${pageID}.list.tabs.materials`),
                    active: true
                }
            ],
            localActive: null
        };
    },
    mounted() {
        this.initialize();
    },
    computed: {
        tableHumanMeans() {
            return {
                ...this.table,
                ...this.tableHumanMeansConfig,
                ...{
                    url: this.form.id ? this.formatString(this.url.getAgents, { id: this.form.id }) : null,
                    urlSearch: this.url.searchAgent,
                    label: this.agentsConfig.label,
                    funcItemHtml: item => this.templater(this.agentsConfig.labelTemplate || this.templateDefault, item)
                }
            };
        },
        tableVehicles() {
            return {
                ...this.table,
                ...this.tableVehiclesConfig,
                ...{
                    url: this.form.id ? this.formatString(this.url.getVehicles, { id: this.form.id }) : null,
                    urlSearch: this.url.searchVehicle,
                    label: this.vehicleConfig.label,
                    funcItemHtml: item => this.templater(this.vehicleConfig.labelTemplate || this.templateDefault, item)
                }
            };
        },
        tableRadios() {
            return {
                ...this.table,
                ...this.tableRadiosConfig,
                ...{
                    url: this.form.id ? this.formatString(this.url.getRadios, { id: this.form.id }) : null,
                    urlSearch: this.url.searchRadio,
                    label: this.radiosConfig.label,
                    funcItemHtml: item => this.templater(this.radiosConfig.labelTemplate || this.templateDefault, item)
                }
            };
        },
        panelConfig() {
            return this.panel.panel || {};
        },
        agentsConfig() {
            return this.panelConfig.agents || {};
        },
        vehicleConfig() {
            return this.panelConfig.vehicles || {};
        },
        radiosConfig() {
            return this.panelConfig.radios || {};
        },
        templateDefault() {
            return '${name}';
        },
        families() {
            return this.lists.families || [];
        },

        maxFiles() {
            return this.panelConfig.maxFiles || 3;
        },
        acceptTypes() {
            return (this.panelConfig.mimeTypes || ['*']).join(', ');
        }
    },
    methods: {
        initialize: function () {
            this.setInitTab();
            this.loadLists();
            if (!this.form.id) {
                this.loaded = true;
            }
        },
        setInitTab: function () {
            this.localActive = this.tabs[0];
        },
        loadLists: function () {
            if (!this.lists.loaded && this.url.getLists) {
                this.$http
                    .get(this.url.getLists)
                    .then(res => {
                        let data = res.data ? res.data : res;
                        Object.keys(data).forEach(key => {
                            if (key in this.lists) {
                                this.lists[key] = data[key];
                            }
                        });
                        this.lists.loaded = true;
                    })
                    .catch(error => {
                        this.lists.loaded = false;
                        this.showHttpError(error);
                    });
            }
        },
        callbackLoadItem() {
            this.loaded = true;
        },
        addItem: function (key, callback) {
            let item = this[key];
            if (!item) {
                return;
            }
            let items = this.form[`${key}s`];
            let id = item.id;
            if (items.add.indexOf(id) == -1) {
                let idxDel = items.del.indexOf(id);
                if (idxDel > -1) {
                    items.del.splice(idxDel, 1);
                } else {
                    items.add.unshift(id);
                }
                if (callback) {
                    callback(Object.assign({}, item));
                }
                this[key] = null;
                this.setFieldDirty(`${key}s`);
            }
        },
        removeItem: function (id, key, callback) {
            let items = this.form[`${key}s`];
            let idxAdd = items.add.indexOf(id);
            if (idxAdd > -1) {
                items.add.splice(idxAdd, 1);
            } else {
                items.del.unshift(id);
            }
            this.setFieldDirty(`${key}s`);
            if (callback) {
                callback(id);
            }
        },
        templater: function (string, obj) {
            return this.$root.$helper.string.interpolate(string, obj);
        },
        onSaveItem: function () {
            this.saveItem(false, ['files']);
        }
    },
    watch: {
        'form.files': {
            deep: true,
            handler() {
                this.setFieldDirty('files');
            }
        }
    }
};
</script>

<style scoped lang="scss">
.list-subtypes {
    label {
        padding-left: 5px;
    }

    .type-parent {
        padding: 0px;
        margin-bottom: 20px;

        & > label {
            font-weight: bold;
            display: block;
            background: #5a6268 -webkit-linear-gradient(#72797e, #5a6268) repeat-x;
            background: #5a6268 -o-linear-gradient(#72797e, #5a6268) repeat-x;
            background: #5a6268 linear-gradient(#72797e, #5a6268) repeat-x;
            color: #fff;
        }
    }
    .type-child {
        margin-bottom: 5px;

        & > label {
            border-bottom: solid 1px #ccc;
            display: block;
        }
    }
}
.list-agents {
    .card {
        width: calc(100% / 4);
        margin: 0px 10px 10px 0px;
        min-height: 368px;

        .photo {
            margin-top: 10px;
            height: 150px;

            img {
                max-height: 150px;
                height: 100%;
                width: 100%;
                object-fit: contain;
            }
        }

        span {
            display: block;
            width: 100%;
        }
    }
}
</style>
